import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import BrandMark from "@/components/BrandMark";
import { useAuth } from "@/context/AuthContext";

export default function PublicHeader({ appPath = "/app" }) {
  const { user } = useAuth();
  return (
    <header className="border-b border-[color:var(--ayur-border)] bg-white/70 backdrop-blur">
      <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="public-brand" className="flex items-center gap-2 text-[color:var(--ayur-emerald)]">
          <BrandMark size={40} />
          <span className="font-serif-display text-2xl font-semibold">VaidGram</span>
        </Link>
        <Link to={user ? appPath : "/signup"}>
          <Button data-testid="public-header-cta" className="bg-[color:var(--ayur-terracotta)] hover:bg-[color:var(--ayur-terracotta)]/90 text-white rounded-full">
            {user ? "Open in app" : "Join VaidGram"}
          </Button>
        </Link>
      </div>
    </header>
  );
}
